module.exports = __webpack_public_path__ + "static/img/erp52.bd6c7ae.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/erp52.jpeg
// module id = z3RI
// module chunks = 73